/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { AppEventMapping, AppEvents } from '../../types/common/AppEvents';

export type INotification<T extends AppEvents = any> = {
  id: string;
  type: T;
  event: AppEventMapping[T];
  isRead?: boolean;
  createdAt: Date;
};

export enum NotificationsActions {
  ADD_NOTIFICATION = 'ADD_NOTIFICATION',
  SET_NOTIFICATIONS = 'SET_NOTIFICATIONS',
  SET_NOTIFICATION_READ = 'SET_NOTIFICATION_READ',
  SET_NOTIFICATIONS_READ = 'SET_NOTIFICATIONS_READ',
  REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION',
}

export type NotificationsState = {
  count: number;
  unreadCount: number;
  readCount: number;
  options: INotification<AppEvents>[];
};

type AddNotificationAction = {
  type: NotificationsActions.ADD_NOTIFICATION;
  payload: { notification: INotification<AppEvents> };
};

type SetNotificationsAction = {
  type: NotificationsActions.SET_NOTIFICATIONS;
  payload: { options: INotification<AppEvents>[] };
};

export type SetNotificationReadAction = {
  type: NotificationsActions.SET_NOTIFICATION_READ;
  payload: { id: string; isRead: boolean };
};

export type SetNotificationsReadAction = {
  type: NotificationsActions.SET_NOTIFICATIONS_READ;
  payload: { isRead: boolean };
};

export type RemoveNotificationAction = {
  type: NotificationsActions.REMOVE_NOTIFICATION;
  payload: { id: string };
};

export type NotificationsActionTypes =
  | AddNotificationAction
  | SetNotificationsAction
  | SetNotificationReadAction
  | SetNotificationsReadAction
  | RemoveNotificationAction;
